module.exports = __webpack_public_path__ + "static/media/Step5.c6ba4a43.jpg";